import React, { useState } from 'react'
import CMD from "../../../../src/assets/img/CMD.svg";
import Availity from "../../../../src/assets/img/Availity.svg";
import OfficeAlly from "../../../../src/assets/img/office-ally.svg";
import Loader from '../../shared/Loader/Loader';
import { Modal, ModalBody } from 'react-bootstrap';
import ModalHeader from './ModalHeader'

const  Clearinghouses = (props) => {
    const { IsOpenClearHo, onClose ,  isLoading , LoadData, GridTableName, SaveTableName, type } = { ...props }
    console.log(props);
    const [isClicked, setIsClicked] = useState(false);



    const handleClick = () => {
        setIsClicked(!isClicked);
      };

    // const masterHeader = () => {
    //     return   <p className="heading fs-14">Integrated Clearinghouses</p>
    // };
    const MasterListModalBody = () => {
        return (
        <>
        <div className="ar-header d-flex align-items-center justify-content-between pb-2 mb-2">
            <p className="heading fs-14">Integrated Clearinghouses</p>
            <i className="icon-Icon-metro-cross fs-12" onClick={onClose}></i>
          </div>
          <div className="ar_content d-flex gap-10 align-items-center">
            <div className="ar_box CMD">
              <div className="mb-2 text-center">
                <img src={CMD} />
              </div>
              <p className="heading dark-blue ar-dot d-flex align-items-center justify-content-center mb-1">Claim <span className="green">&nbsp;MD</span></p>
              <div className={`ar-btn text-white fs-11 text ${isClicked ? 'slected' : ''}`} onClick={handleClick}>{isClicked ? 'Selected' : 'Select'}
              </div>
            </div>
            <div className="ar_box Availity">
              <div className="mb-2 text-center">
                <img src={Availity} />
              </div>
              <p className="heading orange ar-dot d-flex align-items-center justify-content-center mb-1">Availity</p>
              <div className={`ar-btn text-white fs-11 text ${isClicked ? 'slected' : ''}`} onClick={handleClick}>{isClicked ? 'Selected' : 'Select'}
              </div>
            </div>
            <div className="ar_box OfficeAlly">
              <div className="mb-2 text-center">
                <img src={OfficeAlly} />
              </div>
              <p className="heading yamada ar-dot d-flex align-items-center justify-content-center mb-1">Office<span className="dark-blue">&nbsp;Ally</span></p>
              <div className={`ar-btn text-white fs-11 text ${isClicked ? 'slected' : ''}`} onClick={handleClick}>{isClicked ? 'Selected' : 'Select'}
              </div>
            </div>
          </div>
            </>
        )
    }
  return (
    <React.Fragment>
        {type && type === "Wizard" ?
            <div>
                {isLoading ? <Loader /> : null}
                <div className='px-10 pb-15 form-rounded'>
                    {MasterListModalBody()}
                </div>
            </div>
            :
            <Modal show={IsOpenClearHo} isOpen={IsOpenClearHo} onHide={IsOpenClearHo} backdrop="static" keyboard={false} centered className="hk-modal-v1 ar-clearinghouses-popup ">
                <ModalBody>
                    {/* <ModalHeader HeaderName={masterHeader} DeletePopup={""} isClosed={onClose} key={'000'} Name={'MasterList'} /> */}
                    {isLoading ? <Loader /> : null}
                    {MasterListModalBody()}
                </ModalBody>
            </Modal>
        }
    </React.Fragment>
)
}

export default Clearinghouses